<template>
    <div class="information_page">
        <div class="nav_header">
            <p class="nav_box">{{$t('index.youAreHere')}}：{{ navTitle }}</p>
            <p class="back_btn" @click="goback">
                <img src="https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/返回.png" alt="" />
                {{ $t('index.backPreviousPage') }}
            </p>
        </div>
        <!-- 内容 -->
        <h1 class="title_page">{{ $t("studentInfo.title") }}</h1>
        <div class="exam_page">
            <!-- 考试须知 -->
            <div class="exam_type">
                <div class="type_title">{{ $t("studentInfo.subTitle") }}</div>
                <div class="type_desc">
                    <span>{{ $t("studentInfo.one") }} </span>
                    <span class="age"
                        >{{ $t("studentInfo.two")
                        }}</span
                    >
                    <span class="age"
                        >
                        {{ $t("studentInfo.three") }}</span
                    >
                </div>
            </div>
            <div class="rules_title">{{ $t("studentInfo.infoTitle") }}</div>
        </div>
        <!-- 表单 -->
        <div class="registration_form">
            <div class="form_container">
                <el-form
                    :model="formData"
                    :rules="formRules"
                    ref="registrationForm"
                    label-width="0"
                    class="registration_form_content"
                    label-position="top"
                >
                    <!-- 姓(中文) -->
                    <div class="form_field_container">
                        <label class="field_label">{{ $t('studentInfo.lastName') }}</label>
                        <el-form-item
                            prop="lastName"
                            required
                            label-width="100px"
                        >
                            <el-input
                                v-model="formData.lastName"
                                :placeholder="
                                    $t('studentInfo.lastNamePlaceholder')
                                "
                                class="form_input_field"
                                clearable
                            >
                            </el-input>
                        </el-form-item>
                    </div>

                    <!-- 名(中文) -->
                    <div class="form_field_container">
                        <label class="field_label">{{ $t('studentInfo.firstName') }}</label>
                        <el-form-item prop="firstName">
                            <el-input
                                v-model="formData.firstName"
                                :placeholder="
                                    $t('studentInfo.firstNamePlaceholder')
                                "
                                class="form_input_field"
                                clearable
                            >
                            </el-input>
                        </el-form-item>
                    </div>

                    <!-- 姓(拼音) -->
                    <div class="form_field_container">
                        <label class="field_label">{{ $t('studentInfo.lastNamePy') }}</label>
                        <el-form-item prop="lastNamePy">
                            <el-input
                                v-model="formData.lastNamePy"
                                :placeholder="
                                    $t('studentInfo.lastNamePyPlaceholder')
                                "
                                class="form_input_field"
                                clearable
                            >
                                <el-popover
                                    slot="suffix"
                                    placement="top"
                                    width="300"
                                    trigger="click"
                                >
                                    <p>
                                        {{ currentLocale === "zh-CN"?'若您选择的证件上有姓名拼音，请按照与证件一致的拼音填写；若您选择的证件上没有拼音，请按照如下示例填写：Zhang（首字母大写，其它字母小写）':'Enter Pinyin exactly as shown on your ID. If not available, use this format: Zhang (Capitalize first letter only).' }} 
                                     </p>
                                    <i slot="reference" class="el-icon-question question-icon"></i>
                                </el-popover>
                            </el-input>
                        </el-form-item>
                    </div>

                    <!-- 名(拼音) -->
                    <div class="form_field_container">
                        <label class="field_label">{{ $t('studentInfo.firstNamePy') }}</label>
                        <el-form-item prop="firstNamePy">
                            <el-input
                                v-model="formData.firstNamePy"
                                :placeholder="
                                    $t('studentInfo.firstNamePyPlaceholder')
                                "
                                class="form_input_field"
                                clearable
                            >
                                <el-popover
                                    slot="suffix"
                                    placement="top"
                                    width="300"
                                    trigger="click"
                                >
                                    <p>
                                      {{ currentLocale === "zh-CN"?' 若您选择的证件上有姓名拼音，请按照与证件一致的拼音填写；若您选择的证件上没有拼音，请按照如下示例填写：Xiaoming（首字母大写，其它字母小写）':'Enter Pinyin exactly as shown on your ID. If not available, use this format: Xiaoming (Capitalize first letter only).' }} 
                                    </p>
                                    <!-- <p style="margin-top: 10px;"></p> -->
                                    <i slot="reference" class="el-icon-question question-icon"></i>
                                </el-popover>
                            </el-input>
                        </el-form-item>
                    </div>

                    <!-- 电子邮箱 -->
                    <div class="form_field_container">
                        <label class="field_label">{{ $t('studentInfo.email') }}</label>
                        <el-form-item prop="email">
                            <el-input
                                v-model="formData.email"
                                :placeholder="
                                    $t('studentInfo.emailPlaceholder')
                                "
                                class="form_input_field"
                                clearable
                            >
                            </el-input>
                        </el-form-item>
                    </div>

                    <!-- 微信号 -->
                    <div class="form_field_container">
                        <label class="field_label">{{ $t('studentInfo.weChatID') }}</label>
                        <el-form-item prop="WeChat">
                            <el-input
                                v-model="formData.WeChat"
                                :placeholder="
                                    $t('studentInfo.placeholder') +
                                    $t('studentInfo.weChatID')
                                "
                                class="form_input_field"
                                clearable
                            >
                            </el-input>
                        </el-form-item>
                    </div>

                    <!-- 证件类型 -->
                    <div class="form_field_container">
                        <label class="field_label">{{ $t('studentInfo.credentialType') }}</label>
                        <el-form-item prop="credentialType">
                            <el-select
                                v-model="formData.credentialType"
                                :placeholder="
                                    $t('studentInfo.credentialTypePlaceholder')
                                "
                                class="form_select_field"
                                popper-class="custom-select-dropdown"
                            >
                                <el-option
                                    :label="$t('studentInfo.passport')"
                                    value="0"
                                ></el-option>
                                <el-option
                                    :label="$t('studentInfo.IDCard')"
                                    value="1"
                                ></el-option>
                                 <el-option
                                    :label="$t('studentInfo.passport1')"
                                    value="2"
                                ></el-option>
                                 <el-option
                                    :label="$t('studentInfo.passport2')"
                                    value="3"
                                ></el-option>
                                <el-option
                                    :label="$t('studentInfo.passport3')"
                                    value="4"
                                ></el-option>
                                <el-option
                                    :label="$t('studentInfo.passport4')"
                                    value="5"
                                ></el-option>
                                <el-option
                                    :label="$t('studentInfo.passport5')"
                                    value="6"
                                ></el-option>
                                <el-option
                                    :label="$t('studentInfo.passport6')"
                                    value="7"
                                ></el-option>
                                <el-option
                                    :label="$t('studentInfo.passport7')"
                                    value="8"
                                ></el-option>
                                <el-option
                                    :label="$t('studentInfo.passport8')"
                                    value="9"
                                ></el-option>
                                <el-option
                                    :label="$t('studentInfo.passport9')"
                                    value="10"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </div>

                    <!-- 证件号码 -->
                    <div class="form_field_container">
                        <label class="field_label">{{ $t('studentInfo.document') }}</label>
                        <el-form-item prop="passport">
                            <el-input
                                v-model="formData.passport"
                                :placeholder="
                                    $t('studentInfo.documentNumber​Placeholder')
                                "
                                class="form_input_field"
                                clearable
                            >
                            </el-input>
                        </el-form-item>
                    </div>

                    <!-- 出生日期 -->
                    <div class="form_field_container">
                        <label class="field_label">{{ $t('studentInfo.birthDate') }}</label>
                        <el-form-item prop="birthDate">
                            <el-date-picker
                                v-model="formData.birthDate"
                                type="date"
                                :placeholder="
                                    $t('studentInfo.birthDatePlaceholder')
                                "
                                format="yyyy 年 MM 月 dd 日"
                                value-format="yyyy-MM-dd"
                                class="form_date_field"
                                @change="checkAge"
                                :picker-options="birthdayPickerOptions"
                                :default-value="defaultDate"
                                :clearable="false"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </div>

                    <!-- 专属代码 -->
                    <div class="form_field_container">
                        <label class="field_label">{{ $t('studentInfo.channelCode') }}</label>
                        <el-form-item prop="channelCode">
                            <el-input
                                v-model="formData.channelCode"
                                :placeholder="$t('studentInfo.channelPlaceholder')" 
                                class="form_input_field"
                                clearable
                                :disabled="channelCodeDisabled"
                            >
                            </el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <!-- 未成年提示 -->
                <div class="underage_warning_container" v-if="showAdultNotice">
                    <div class="underage_warning_content">
                        <p class="underage_warning_text">
                            <i
                                class="el-icon-warning-outline"
                                style="color: red"
                            ></i>
                            <template v-if="currentLocale === 'zh-CN'">
                                <span>检测到您<span class="highlight">未满16周岁</span></span>
                                <span>请添加牛津考小助手微信并由监护人签署《考生监护人确认书》</span>
                                </template>
                            <template v-else>
                                <span>You have been identified as being <span class="highlight">
                                    under 16 years old.
                                </span> </span>
                                <p>Please add the customer service on WeChat and ask your parent or guardian to sign the Candidate Guardian Confirmation Form.</p>
                            </template>
                            
                            <!-- ，并且尚未由监护人签署《考生监护人确认书》，签署后方可继续报名。 -->
                        </p>
                        <!-- <el-button
                            type="text"
                            class="sign_button"
                            @click="handleSignClick"
                        >
                            立即签署
                        </el-button> -->
                    </div>
                </div>

                <!-- 提交按钮 -->
                <div class="submit_button_container">
                    <div @click="checkAgreement" class="radio_box">
                        <div class="radio">
                            <div :class="agreed ? 'active' : ''"></div>
                        </div>
                        <div class="content" v-html="agreementText">
                            <!-- {{ agreementText }} -->
                        </div>
                    </div>
                    <el-button
                        type="primary"
                        class="submit_button"
                        @click="handleSubmit"
                        :disabled="showAdultNotice"
                    >
                        {{ $t('studentInfo.nextStep') }}
                    </el-button>
                </div>
            </div>

            <!-- 签署对话框 -->
            <el-dialog
                :visible.sync="showSignDialog"
                width="40%"
                center
                :title="currentTitle"
                :lock-scroll="true"
            >
                <!-- <div class="sign_dialog_content">
                    <div class="sign_area">
                        <p>{{ currentTitle }}</p>
                    </div>
                    <div
                        class="sign_area"
                        ref="scrollContainer"
                        @scroll="handleScroll"
                    >
                        <div class="content-text">
                            <img
                                v-for="item in currentAgreementImages"
                                :key="item"
                                :src="item"
                            />
                        </div>
                    </div>
                </div> -->
                <div
                    class="sign_dialog_content"
                    ref="scrollContainer"
                    @scroll="handleScroll"
                >
                    <div v-for="page in pages" :key="page.pageNumber">
                        <pdf
                            :src="pdfDocument"
                            :page="page.pageNumber"
                            @error="onPageError(page.pageNumber, $event)"
                            @progress="onPageProgress(page.pageNumber, $event)"
                            @num-pages="updateTotalPages"
                            class="pdf-page"
                        />
                    </div>
                </div>

                <span slot="footer" class="dialog_footer">
                    <div
                        class="btn"
                        :class="isRead ? 'active' : ''"
                        @click="handleAgree"
                    >
                        {{
                            isRead
                                ? $t("studentInfo.readTwo") +
                                  `(${currentAgreementIndex + 1}/${
                                      agreements.length
                                  })`
                                : $t("studentInfo.readTwo") +
                                  `(${currentAgreementIndex + 1}/${
                                      agreements.length
                                  })`
                        }}
                    </div>
                </span>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import pdf from "vue-pdf";
import { getLegalPdf, verifyChannel } from "@/plugins/api";
import { toCST } from "@/utils/date";
export default Vue.extend({
    data() {
        return {
            navTitle: "",
            formData: {
                lastName: "",
                firstName: "",
                lastNamePy: "",
                firstNamePy: "",
                email: "",
                WeChat: "",
                credentialType: "1",
                passport: "",
                birthDate: "",
                channelCode: "",
            },
            formRules: {
                lastName: [
                    {
                        required: true,
                        message: this.$t("studentInfo.lastNamePlaceholder"),
                        trigger: "blur",
                    },
                ],
                firstName: [
                    {
                        required: true,
                        message: this.$t("studentInfo.firstNamePlaceholder"),
                        trigger: "blur",
                    },
                ],
                lastNamePy: [
                    {
                        required: true,
                        message: this.$t("studentInfo.lastNamePyPlaceholder"),
                        trigger: "blur",
                    },
                    {
                        // pattern: /^[a-zA-Z]+$/,
                        // message: "拼音只能包含字母",
                        trigger: "blur",
                    },
                ],
                firstNamePy: [
                    {
                        required: true,
                        message: this.$t("studentInfo.firstNamePyPlaceholder"),
                        trigger: "blur",
                    },
                    {
                        // pattern: /^[a-zA-Z]+$/,
                        // message: "拼音只能包含字母",
                        trigger: "blur",
                    },
                ],
                email: [
                    {
                        required: true,
                        message: this.$t("studentInfo.emailPlaceholder"),
                        trigger: "blur",
                    },
                    {
                        pattern:
                            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                        message: this.$t("studentInfo.emailtruePlaceholder"),
                        trigger: "blur",
                    },
                ],
                WeChat: [
                    {
                        required: true,
                        message:
                            String(this.$t("studentInfo.placeholder")) +
                            String(this.$t("studentInfo.weChatID")),
                        trigger: "blur",
                    },
                ],
                passport: [
                    {
                        required: true,
                        message: this.$t(
                            "studentInfo.documentNumber​Placeholder"
                        ),
                        trigger: "blur",
                    },
                ],
                birthDate: [
                    {
                        required: true,
                        message: this.$t("studentInfo.birthDatePlaceholder"),
                        trigger: "change",
                    },
                ],
            },
            showUnderageWarning: false,
            showSignDialog: false,
            agreeToTerms: false,
            birthdayPickerOptions: {
                // disabledDate(time) {
                //     return time.getTime() > Date.now();
                // },
                disabledDate: (time) => {
                    const limitDate = toCST(Date.now()).subtract(14, "years").startOf("day").valueOf();
                    return time.getTime() > limitDate;
                },
            },
            agreed: false,
            showAdultNotice: false,
            agreements: [],
            currentAgreementIndex: 0,
            readTitle: null,
            currentTitle: null,
            isRead: false,
            currentLocale: "zh-CN",
            channelCode: null,
            channelCodeDisabled: false,
            loading: false,
            error: null,
            pdfDocument: null,
            pages: [],
            totalPages: 0,
            loadedPages: 0,
            scale: 1,
            pageLoadErrors: [],
        };
    },
    props: {},
    watch: {
        "$i18n.locale": {
            handler(newVal) {
                this.currentLocale = newVal || "zh-CN";
                this.updateCurrentTitle();
                this.navTitle = this.$route.meta && this.currentLocale === "zh-CN" ? this.$route.meta.title : this.$route.meta.titleEn;
            },
            immediate: true,
        },
        // 监听当前协议索引变化，更新标题
        currentAgreementIndex() {
            this.updateCurrentTitle();
        },
        showSignDialog: {
            handler(newVal) {
                if (newVal) {
                    document.body.style.overflow = "hidden";
                } else {
                    document.body.style.overflow = "unset";
                }
            },
        }
    },
    components: {
        pdf,
    },
    mounted() {
        if (this.$store.state.auth.studentInfo) {
            // 缓存选择数据
            const userInfo = this.$store.state.auth.studentInfo;
            if (userInfo.formData) {
                this.formData = userInfo.formData;
            }
        }
        if (sessionStorage.getItem("channelCode")) {
            this.$set(this.formData, "channelCode", sessionStorage.getItem("channelCode"))
            this.channelCodeDisabled = true; // 手动禁用
        }
        const defaultDate = toCST(Date.now()).subtract(14, "years");
        const year = defaultDate.year();
        const month = String(defaultDate.month() + 1).padStart(2, "0");
        const day = String(defaultDate.date()).padStart(2, "0");
        // this.formData.birthDate = `${year}-${month}-${day}`; // ✅ 设置默认值
        // this.$set(this.formData, "birthDate", `${year}-${month}-${day}`)
        this.loadAllPages();
    },
    created() {},
    computed: {
        agreementText() {
            if (!this.agreements || this.agreements.length === 0) {
                return this.currentLocale === "zh-CN"
                    ? `我已阅读并同意 <span style="color: #1890ff;">《服务协议》、《隐私政策》和《考生须知》。<span>`
                    : `I have read and agree to the Terms of <span style="color: #1890ff;">Service Agreement, Privacy Policy, and Test-taker Instructions.<span>`;
            }

            const isZh = this.currentLocale === "zh-CN";
            const agreementNames = this.agreements.map((item) =>
                isZh ? item.name : item.nameEn
            );

            if (isZh) {
                return `我已阅读并同意 <span style="color: #1890ff;">《${agreementNames.join("》、《")}》。</span>`;
            } else {
                if (agreementNames.length === 1) {
                    return `I have read and agree to the <span style="color: #1890ff;">${agreementNames[0]}.<span>`;
                } else if (agreementNames.length === 2) {
                    return `I have read and agree to the <span style="color: #1890ff;"> ${agreementNames[0]} and ${agreementNames[1]}.</span>`;
                } else {
                    const last = agreementNames.pop();
                    return `I have read and agree to the <span style="color: #1890ff;"> ${agreementNames.join(
                        ", "
                    )} and ${last}.<span>`;
                }
            }
        },
        // 添加计算属性获取当前语言的图片数组
        currentAgreementImages() {
            if (!this.agreements[this.currentAgreementIndex]) {
                return [];
            }
            const agreement = this.agreements[this.currentAgreementIndex];
            // 根据当前语言选择对应的图片数组
            return this.currentLocale === "zh-CN"
                ? agreement.imageUrl || []
                : agreement.imageUrlEn || [];
        },
        defaultDate() {
            return toCST(Date.now()).subtract(14, "years").toDate();
        }
    },
    created() {
        // this.navTitle = this.$route.meta.title;
        this.getLegalList();
    },
    methods: {
        checkAgreement() {
            this.showSignDialog = true;
            this.isRead = false;
            this.currentAgreementIndex = 0;
            this.$nextTick(() => {
                this.loadAllPages();
            });
        },
        async loadAllPages() {
            this.loading = true;
            this.error = null;
            this.pages = [];
            this.loadedPages = 0;
            this.pageLoadErrors = [];
            this.totalPages = 0;
            // 销毁 PDF 文档
            if (this.pdfDocument) {
                try {
                    if (typeof this.pdfDocument.destroy === "function") {
                        await this.pdfDocument.destroy();
                    }
                } catch (err) {
                    console.error("Error destroying PDF:", err);
                }
                this.pdfDocument = null;
            }
            try {
                // 加载 PDF 文档
                if (
                    !this.agreements ||
                    !this.agreements[this.currentAgreementIndex]
                ) {
                    throw new Error("协议不存在");
                }
                // 获取 PDF URL
                const agreement = this.agreements[this.currentAgreementIndex];
                const pdfUrl =
                    this.currentLocale === "zh-CN"
                        ? agreement.pdfUrl
                        : agreement.pdfUrlEn;

                if (!pdfUrl) {
                    throw new Error("PDF URL 不存在");
                }
                const loadingTask = await pdf.createLoadingTask({
                    url: pdfUrl,
                    withCredentials: false,
                    // 关键配置：字体渲染选项
                    // cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.16.105/cmaps/',
                    // cMapPacked: true,
                    // // 标准字体配置
                    // standardFontDataUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.16.105/standard_fonts/',
                    // 渲染选项
                    renderInteractiveForms: true,
                    enableXfa: false,  // 禁用 XFA 可能有助于解决标点问题
                    // 字体配置
                    useSystemFonts: false,
                    fontExtraProperties: true,
                    // 禁用某些可能导致问题的特性
                    disableFontFace: false,
                    disableRange: true,
                    disableStream: true,
                    disableAutoFetch: true,
                    pdfBug: false
                });

                this.pdfDocument = loadingTask;
                const doc = await this.pdfDocument.promise;
                this.totalPages = doc.numPages;
                // 创建页面数组
                for (let i = 1; i <= this.totalPages; i++) {
                    this.pages.push({
                        pageNumber: i,
                        loaded: false,
                        error: null,
                        canvasReady: false,
                        retryCount: 0,
                    });
                }
                console.log(this.pages, "idsodisidisiod+++");
                // 监听所有页面加载完成
                await this.waitForAllPages();
            } catch (err) {
                // this.error = `文档加载失败: ${err.message || '未知错误'}`
                this.loading = false;
            }
        },
        waitForAllPages() {
            // 检查所有页面是否加载完成
            const checkInterval = setInterval(() => {
                if (
                    this.loadedPages + this.pageLoadErrors.length >=
                    this.totalPages
                ) {
                    clearInterval(checkInterval);
                    this.loading = false;
                    if (this.pageLoadErrors.length > 0) {
                        // this.error = `${this.pageLoadErrors.length}个页面加载失败`
                    }
                }
            }, 100);
        },

        onPageProgress(pageNumber, progress) {
            // 页面加载进度
            console.log(`页面 ${pageNumber} 加载进度:`, progress);
        },

        onPageError(pageNumber, error) {
            // console.error(`页面 ${pageNumber} 加载失败:`, error)
            this.pageLoadErrors.push({ pageNumber, error });
            // 更新页面状态
            const page = this.pages.find((p) => p.pageNumber === pageNumber);
            if (page) {
                page.error = error;
            }
        },
        updateTotalPages(pageCount) {
            // 确保总页数正确
            if (pageCount && pageCount > this.totalPages) {
                this.totalPages = pageCount;
            }
        },
        handleScroll(e) {
            const element = this.$refs.scrollContainer;
            const { scrollTop, clientHeight, scrollHeight } = element;
            // 判断是否接近底部（可根据需要调整阈值）
            const threshold = 50; // 距离底部50px时触发
            const isNearBottom =
                scrollTop + clientHeight >= scrollHeight - threshold;
            if (isNearBottom) {
                this.isRead = true;
            }
        },
        goback() {
            this.$router.go(-1);
        },
        // 处理签署按钮点击
        handleSignClick() {
            this.showSignDialog = true;
        },
        // 确认签署监护人确认书
        confirmSign() {
            this.$message.success("监护人确认书签署成功！");
            this.showSignDialog = false;
            this.showUnderageWarning = false;
            this.agreeToTerms = false;
        },
        checkAge(value) {
            this.$set(this.formData, 'birthDate', value)
            const birthM = toCST(this.formData.birthDate);
            const today = toCST(Date.now());

            let age = today.year() - birthM.year();
            const monthDiff = today.month() - birthM.month();

            if (
                monthDiff < 0 ||
                (monthDiff === 0 && today.date() < birthM.date())
            ) {
                age--;
            }

            this.showAdultNotice = age < 16;
        },
        // 提交表单
        async handleSubmit() {
            if (!this.agreed) {
                this.$message({
                    message:
                        this.$i18n.locale === "zh-CN"
                            ? "请先阅读并同意协议"
                            : "Please read and agree to the agreement first",
                    type: "warning",
                });
                return;
            }
            this.$refs.registrationForm.validate(async (valid) => {
                if (valid) {
                    if (this.showUnderageWarning) {
                        this.$message.warning("请先签署《考生监护人确认书》");
                        return;
                    }
                    // 验证渠道码
                    const verifyResult = await this.verifyChannelCode();

                    if (!verifyResult.success) {
                        this.$message.error(verifyResult.message);
                        return;
                    }
                    // if (this.channelCode) {
                    //     this.formData.channelCode = this.channelCode;
                    // }
                    this.$store.dispatch("auth/updateStudentPartial", {
                        formData: this.formData,
                    });
                    // 在实际应用中，这里应该发送数据到后端API
                    this.$router.push("/registration");
                    
                } else {
                    this.$message.error("请正确填写所有必填信息");
                    return false;
                }
            });
        },
        // 验证渠道码
        async verifyChannelCode() {
            if (!this.formData.channelCode || this.formData.channelCode.trim() === "") {
                // 渠道码为空，直接通过验证
                return {
                    success: true,
                };
            }

            try {
                // this.isVerifying = true;
                const res = await verifyChannel({
                    channelCode: this.formData.channelCode.trim(),
                });
                // this.isVerifying = false;
                const obj = {
                    success: true,
                };
                return obj;
            } catch (error) {
                // this.isVerifying = false;
                return {
                    success: false,
                    message:
                        this.currentLocale === "zh-CN"
                            ? error.data.error.returnUserMessage
                            : error.data.error.returnUserMessageEn,
                };
            }
        },
        // 处理协议同意
        handleAgree() {
            if (this.isRead) {
                if (this.currentAgreementIndex < this.agreements.length - 1) {
                    // 如果不是最后一个协议，切换到下一个
                    this.currentAgreementIndex++;
                    this.updateCurrentTitle();
                    // 重置滚动位置
                    setTimeout(() => {
                        this.$refs.scrollContainer.scrollTop = 0;
                        this.isRead = false;
                        this.agreed = false;
                    }, 100);
                    this.$nextTick(() => {
                        this.loadAllPages();
                    });
                } else {
                    // 如果是最后一个协议，关闭弹窗并设置同意状态
                    this.showSignDialog = false;
                    this.isRead = true;
                    this.agreed = true;
                }
            } else {
                let title =
                    this.$i18n.locale === "zh-CN"
                        ? "请阅读完整协议内容"
                        : "Please read the complete agreement content";
                this.$message.warning(title);
                this.agreed = false;
            }
        },
        goTop() {
            this.$nextTick(() => {
                const element = this.$refs.scrollContainer;
                if (!element) return;
                element.scrollTop = 0;
            });
        },
        // 获取法律文件
        async getLegalList() {
            let loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            try {
                const res = await getLegalPdf({
                    type: "2", //2：报名协议；1:登录注册协议
                });

                if (res.rows && res.rows.length > 0) {
                    // res.rows = res.rows.map((item) => {
                    //     // 处理图片URL，将http转换为https
                    //     if (item.imageUrl && item.imageUrl.length) {
                    //         item.imageUrl = item.imageUrl.map((url) =>
                    //             url.replace("http://", "https://")
                    //         );
                    //     }
                    //     if (item.imageUrlEn && item.imageUrlEn.length) {
                    //         item.imageUrlEn = item.imageUrlEn.map((url) =>
                    //             url.replace("http://", "https://")
                    //         );
                    //     }

                    //     return item;
                    // });
                    this.agreements = res.rows;
                    this.updateCurrentTitle();
                    loading.close();
                } else {
                    console.warn("未获取到协议内容");
                    this.agreements = [];
                    loading.close();
                }
            } catch (error) {
                console.error("获取协议失败:", error);
                this.agreements = [];
                loading.close();
            }
        },
        // 更新当前协议标题
        updateCurrentTitle() {
            if (
                this.agreements &&
                this.agreements[this.currentAgreementIndex]
            ) {
                this.currentTitle =
                    this.currentLocale === "zh-CN"
                        ? this.agreements[this.currentAgreementIndex].name
                        : this.agreements[this.currentAgreementIndex].nameEn;
            }
        }
    },
});
</script>
<style lang="stylus" scoped>
.question-icon {
    cursor: pointer;
    // color: red;
    font-size: 26px;
    margin-right: 8px;
    margin-top: 8px;
    &:hover {
        color: #409EFF;
    }
}

.information_page {
    min-height: calc(100vh - 620px);
    margin-bottom: 200px;

    .nav_header {
        display: flex;
        flex-flow: row;
        align-items: center;
        justify-content: space-between;

        .nav_box {
            padding: 20px 0;
            font-size: 15px;
            color: #333;
        }

        .back_btn {
            display: flex;
            flex-flow: row;
            align-items: center;
            font-size: 15px;

            img {
                width: 20px;
                margin-right: 10px;
            }
        }
    }

    .title_page {
        width: 100%;
        text-align: center;
        margin-bottom: 30px;
    }

    .exam_page {
        color: #333;
        max-width: 1200px;
        margin: 0 auto;
        padding: 20px;
        background: #fff;
        position: relative;
        z-index: 2;

        .exam_type {
            margin-bottom: 30px;
            background-image: url('https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/全项组合.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;
            min-height: 160px;
            display: flex;
            flex-flow: column;
            align-items: center;
            justify-content: center;
            color: #fff;
            position: relative;

            .type_title {
                font-size: 24px;
                font-weight: bold;
                margin-bottom: 10px;
                position: relative;
            }

            .type_title::after {
                content: '';
                position: absolute;
                bottom: -10px;
                left: 50%;
                margin-left: -20px;
                width: 40px;
                height: 4px;
                background: #fff;
                z-index: 1;
            }

            .type_desc {
                display: flex;
                flex-direction: column;
                font-size: 16px;
                text-align: center;
                margin-top: 18px;
            }
        }
    }

    .rules_title {
        font-weight: bold;
        margin-bottom: 15px;
        font-size: 22px;
        color: #011E41;
    }
}

.page-container {
    margin-bottom: 24px;
    text-align: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    background: white;
    border-radius: 8px;
    overflow: hidden;
    transition: transform 0.2s ease;
}

.page-container:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.pdf-page {
    display: block;
    max-width: 100%;
    height: auto;
}

.page-footer {
    padding: 8px 12px;
    background: #f8f9fa;
    border-top: 1px solid #dee2e6;
    font-size: 14px;
    color: #6c757d;
}

.loading-state {
    text-align: center;
    padding: 60px 20px;
    color: #495057;
}

// 表单
.registration_form {
    font-family: 'Helvetica Neue', Arial, 'PingFang SC', 'Microsoft YaHei', sans-serif;
    background-color: #f5f7fa;
    display: flex;
    justify-content: center;
    align-items: flex-start;

    .form_container {
        background-color: #ffffff;
        width: 100%;
        padding: 20px 20px 28px 20px;

        .registration_form_content {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(520px, 1fr));
            gap: 20px;

            .form_field_container {
                .field_label {
                    display: block;
                    margin-bottom: 12px;
                    color: #898989;
                    font-size: 14px;
                    font-weight: 500;
                }

                .form_input_field, .form_select_field, .form_date_field {
                    width: 100%;
                }

                ::v-deep .el-form-item {
                    margin-bottom: 4px;

                    .el-form-item__error {
                        padding-top: 4px;
                    }
                }
            }
        }

        .underage_warning_container {
            margin: 30px 0;
            padding: 10px 20px;
            background: #FFF7F7;
            border-radius: 10px;
            border: 1px solid #F5CDCD;

            .underage_warning_content {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;

                .underage_warning_text {
                    color: #000;
                    font-size: 14px;
                    line-height: 1.5;
                }

                .sign_button {
                    color: #0043E0;

                    &:hover, &:focus {
                        // background-color: #ebb563;
                        border-color: #ebb563;
                    }
                }
            }
        }

        .submit_button_container {
            margin-top: 88px;
            text-align: center;

            .radio_box {
                position: relative;
                display: flex;
                flex-flow: row;
                justify-content: center;
            }

            .radio {
                width: 22px;
                height: 22px;
                border-radius: 50%;
                border: 1px solid #aaa;
                // top: 25px;
                display: flex;
                flex-flow: row;
                justify-content: center;
                align-items: center;

                .active {
                    width: 12px;
                    height: 12px;
                    background-color: #797979;
                    border-radius: 50%;
                }

                margin-right: 10px;
            }

            .content {
                font-size: 14px;
                color: #333;
                // flex: 1;
            }

            .submit_button {
                width: 280px;
                height: 72px;
                // background: #0043E0;
                border-radius: 36px;
                font-size: 28px;
                // color: #FFFFFF;
                margin-top: 10px;

                &:hover, &:focus {
                    background-color: #66b1ff;
                    border-color: #66b1ff;
                }
            }
        }
    }

    .sign_dialog_content {
        max-height: 500px;
        overflow-y: auto;
        // background-color: #f5f7fa;
        border-radius: 4px;
        font-size: 14px;
        line-height: 1.6;
        color: #606266;

        // .sign_area {
        // // margin: 0px 0;
        // // padding: 15px;
        // max-height: 500px;
        // overflow-y: auto;
        // // background-color: #f5f7fa;
        // border-radius: 4px;
        // font-size: 14px;
        // line-height: 1.6;
        // color: #606266;

        // >p {
        // margin-bottom: 8px;
        // text-align: center;
        // font-size: 18px;
        // font-weight: bold;
        // }

        // img {
        // width: 100%;
        // }
        // }
        .sign_checkbox {
            margin-top: 20px;

            ::v-deep .el-checkbox__label {
                font-size: 14px;
            }
        }
    }

    ::v-deep .el-dialog__title {
        font-weight: 500;
        color: #303133;
    }

    .dialog_footer {
        text-align: center;

        .btn {
            padding: 12px 20px;
            border-radius: 30px;
            text-align: center;
            background: #ddd;
            color: #666;
            transition: all 0.3s;
        }

        .btn.active {
            background: #ff3054;
            color: white;
        }
    }
}

/* 响应式设计 */
@media (max-width: 640px) {
    .registration_form {
        .form_container {
            padding: 0 20px 8vw 20px;

            .registration_form_content {
                grid-template-columns: repeat(auto-fit, minmax(80vw, 1fr));
                gap: 6vw;

                .form_field_container {
                    // margin-bottom: 2vw;
                }
            }

            .underage_warning_container {
                .underage_warning_content {
                    flex-flow: column;

                    .underage_warning_text {
                        font-size: 3.6vw;
                    }

                    .el-button {
                        font-size: 3.8vw;
                        padding: 0.8vw 2.4vw;
                    }
                }

                margin: 8vw 0;
                padding: 4vw;
            }

            .submit_button_container {
                margin-top: 10vw;

                .radio {
                    width: 4.8vw;
                    height: 4.8vw;
                    border-radius: 50%;

                    .active {
                        width: 2vw;
                        height: 2vw;
                        border-radius: 50%;
                    }

                    margin-right: 0.1vw;
                }

                .content {
                    font-size: 3.8vw;
                }

                .submit_button {
                    width: 100%;
                    height: 12.8vw;
                    font-size: 5.6vw;
                    margin-top: 4.8vw;
                }
            }
        }
    }
}

@media (max-width: 640px) {
    .information_page {
        min-height: calc(100vh - 20vw);
        margin-bottom: 20vw;

        .exam_page {
            padding: 3vw;

            .exam_type {
                margin-bottom: 5vw;
                background-image: url('https://gecacademy.oss-cn-beijing.aliyuncs.com/ote/oteimg/全项组合移动.png');

                .type_title {
                    font-size: 4.8vw;
                }

                .type_title::after {
                    width: 14vw;
                    height: 1vw;
                    margin-left: -7vw;
                }

                .type_desc {
                    font-size: 3.2vw;
                    max-width: 96%;
                }
            }
        }

        .rules_title {
            font-size: 4.8vw;
            text-align: center;
            margin-bottom: 0;
        }

        >>>.el-dialog {
            width: 100% !important;
            height: 100% !important;
        }

        .registration_form .dialog_footer .btn {
            padding: 2vw 4vw;
            font-size: 3.2vw;
        }
    }
}
</style>